module.exports = __webpack_public_path__ + "img/1.4b92925.png";